<template>
  <div class="ts-border ts-p-3 ts-rounded-md ts-space-y-3">
    <div>
      <h3
        class="ts-text-lg ts-font-semibold ts-bg-blue-100 ts-px-2 ts-rounded-md ts-py-1 ts-text-blue-500"
        style="width: fit-content;"
      >
        {{ $t('single-copy.student_score') }}
      </h3>
    </div>
    <div class="ts-h-64" v-if="students.length == 0">
      <div
        class="ts-flex ts-flex-col ts-justify-center ts-items-center ts-h-full"
      >
        <i class="fas fa-folder-open fa-3x ts-text-gray-300"></i>
        <p class="ts-text-xl ts-text-gray-300">
          {{ $t('single-copy.no_data') }}
        </p>
      </div>
    </div>
    <div class="ts-w-full ts-overflow-auto" v-if="students.length > 0">
      <table class="ts-w-full ts-rounded">
        <thead>
          <tr class="ts-bg-gray-200">
            <th
              valign="middle"
              rowspan="2"
              class="ts-uppercase ts-border ts-py-1 ts-px-3 ts-text-center"
              style="width: 10px;"
            >
              {{ $t('numberic') }}
            </th>
            <th
              valign="middle"
              rowspan="2"
              class="ts-uppercase ts-whitespace-no-wrap ts-border ts-py-1 ts-px-3"
            >
              {{ $t('studentScoringEntry.studentNameKH') }}
            </th>
            <th
              valign="middle"
              rowspan="2"
              class="ts-uppercase ts-whitespace-no-wrap ts-border ts-py-1 ts-px-3"
            >
              {{ $t('studentScoringEntry.studentNameEN') }}
            </th>
            <th
              valign="middle"
              rowspan="2"
              class="ts-uppercase ts-border ts-py-1 ts-px-3 ts-w-24 ts-text-center"
            >
              {{ $t('studentScoringEntry.sex') }}
            </th>
            <th
              v-for="(entity, index) in tableHeaderSubject"
              class="ts-uppercase ts-border ts-py-1 ts-px-3 ts-text-center ts-whitespace-no-wrap"
              :colspan="entity.colspan"
              :key="index"
            >
              <div class="ts-w-full ts-relative">
                <p>
                  {{
                    // eslint-disable-next-line prettier/prettier
                    $i18n.locale == 'en'
                      ? entity.name
                        ? entity.name
                        : entity.name_native
                      : entity.name_native
                      ? entity.name_native
                      : entity.name
                  }}
                </p>
                <p v-if="model.score_sc_bas_id == 2">
                  {{ showMaxScore(entity.id) }}
                </p>
              </div>
            </th>
            <th
              rowspan="2"
              class="ts-uppercase ts-border ts-py-1 ts-px-3 ts-text-center ts-whitespace-no-wrap"
            >
              {{ $t('actions') }}
            </th>
          </tr>
          <tr v-if="model.score_sc_bas_id == 1" class="ts-bg-gray-200">
            <template v-for="(entity, _index) in tableHeaderSubject">
              <th
                class="ts-border ts-px-3 ts-whitespace-no-wrap"
                style="width: 60px;"
                v-for="(item, index) in entity.items"
                :key="index + '_' + _index"
              >
                <div class="ts-w-full ts-relative ts-text-center">
                  <p>{{ item.name.split(' ')[0] }}</p>
                  <p>{{ showMaxScore(item.id) }}</p>
                </div>
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(student, index) in model.sc_item_subject_comp_list"
            :key="index"
            class="row-hover"
          >
            <td class="ts-text-center ts-px-3 ts-border ts-w-6">
              {{ index + 1 }}
            </td>
            <td class="ts-text-left ts-px-3 ts-border ts-w-48">
              {{
                studentComputed(student.student_id)
                  ? studentComputed(student.student_id).first_name_kh +
                    ' - ' +
                    studentComputed(student.student_id).last_name_kh
                  : ''
              }}
            </td>
            <td class="ts-text-left ts-px-3 ts-border ts-w-48 ts-relative">
              {{
                studentComputed(student.student_id)
                  ? studentComputed(student.student_id).first_name_en +
                    ' - ' +
                    studentComputed(student.student_id).last_name_en
                  : ''
              }}
            </td>
            <td class="ts-text-center ts-px-3 ts-border">
              {{
                studentComputed(student.student_id)
                  ? studentComputed(student.student_id).gender
                  : ''
              }}
            </td>
            <td
              v-for="(score, scoreIndex) in student.scores"
              :key="scoreIndex"
              class="ts-border ts-px-3 ts-whitespace-no-wrap overflow-hidden ts-text-center"
              style="width: 60px;"
            >
              <input
                v-model.number="score.actual_score"
                :disabled="score.disabledInput"
                type="number"
                step="any"
                placeholder="-"
                class="ts-w-full ts-px-2 ts-py-1 ts-outline-none ts-text-center"
                style="min-width: 40px;"
                :max="score.max_score"
                @input="validateInput(score, score.max_score)"
              />
            </td>
            <td
              class="ts-border ts-px-3 ts-whitespace-no-wrap ts-w-4 overflow-hidden ts-text-center"
            >
              <a
                href="#"
                class="mr-2 text-primary"
                @click="onStudentRowClickComment(student)"
              >
                <i class="fas fa-comment-alt"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- input student comment  -->

      <a-modal
        v-if="inputComment"
        v-model="inputComment"
        :title="$t('studentScoringEntry.comment')"
      >
        <CommentComponents
          v-model="commentOnStudent"
          :scoringCycleId="model.scoring_cycle_id"
          :cycleValue="model.cycle_value"
        />
        <template v-slot:footer>
          <ts-button color="primary" @click="() => (inputComment = false)">{{
            $t('ok')
          }}</ts-button>
        </template>
      </a-modal>

      <!-- end student comment -->
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapMutations } from 'vuex'
import notificationAlert from '@/utils/NotificationAlert'

import CommentComponents from './commentComponent.vue'

import {
  getScore,
  formViewModel as studentScoreFormViewModel,
  getScoreComponentAverage
} from '@/api/student-scoring-table-entry'
export default {
  name: 'StudentScore',
  props: ['value'],
  components: {
    CommentComponents
  },
  data() {
    return {
      errors: new Errors(),
      inputComment: false,
      commentOnStudent: undefined,

      model: {},
      loading: false,
      subjects: [],
      scoreEntities: [],
      students: []
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    showMaxScore: vm => id => {
      if (id !== undefined && vm.model.sc_item_subject_comp_list) {
        const score = vm.model.sc_item_subject_comp_list[0]
        if (score) {
          const findMaxScore = score.scores.find(
            s => s.sc_item_subject_comp_id == id
          )
          return findMaxScore ? findMaxScore.max_score : 'N/A'
        }
      }

      return undefined
    },
    tableHeaderSubject() {
      return this.scoreEntities
        .filter(sc => {
          if (this.model.score_sc_bas_id == 1) {
            return sc.items.length > 0
          }
          return true
        })
        .map(el => ({
          id: el.id,
          name_native: el.name_native,
          name: el.name,
          colspan: this.model.score_sc_bas_id == 1 ? el.items.length : 0,
          items: el.items
        }))
    },
    studentComputed: vm => studentId => {
      if (studentId !== undefined) {
        return vm.students.find(s => s.student_id === studentId)
      }
      return undefined
    }
  },
  methods: {
    ...mapActions('scoreCopy', ['formViewModel']),
    ...mapMutations('scoreCopy', ['SET_LOADING']),
    filterOption(input, option) {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    fetchEntities() {
      return studentScoreFormViewModel({
        params: {
          fnName: 'scoreEntities',
          class_id: this.model.class_id,
          score_type: this.model.score_type
        }
      })
        .then(({ data }) => {
          if (data.scoreEntities !== null) {
            this.scoreEntities = data.scoreEntities.entities
          }
        })
        .catch(error => {
          notificationAlert(error)
        })
    },
    createStudentScore() {
      this.students.forEach(student => {
        this.model.sc_item_subject_comp_list.push({
          student_id: student.student_id,
          st_class_id: student.st_class_id,
          comments: '',
          advisor_id: '',
          sc_stu_com_id: '',
          scores: []
        })
      })

      this.model.sc_item_subject_comp_list.forEach(student => {
        this.scoreEntities.forEach(subject => {
          this.model.program_structure_id = subject.program_structure_id
          // item base
          if (this.model.score_sc_bas_id == 1 && subject.items.length > 0) {
            subject.items.forEach(item => {
              student.scores.push({
                disabledInput: false,
                sc_subject_id: subject.id,
                scoring_id: 0,
                sc_item_subject_comp_id: item.sc_item_subject_comp_id,
                actual_score: null,
                max_score: this.setMaxScore(item)
              })
            })
          }

          if (this.model.score_sc_bas_id == 2) {
            // subject base
            student.scores.push({
              disabledInput: false,
              sc_subject_id: subject.id,
              scoring_id: 0,
              sc_item_subject_comp_id: subject.id,
              actual_score: null,
              max_score: this.setMaxScore(subject)
            })
          }
        })
      })
    },
    setMaxScore(itemScore) {
      if (
        this.model.ac_category_id === 2 &&
        this.model.scoring_cycle_id === 1
      ) {
        // Sciense and monthly
        return itemScore.actual_score_sciense
      }
      if (
        this.model.ac_category_id === 2 &&
        [0, 2, 3].includes(this.model.scoring_cycle_id)
      ) {
        // Sciense and semester/term
        if (itemScore.enable_sciense && itemScore.enable_semester) {
          return itemScore.actual_score_sciense_semester
        }
        return itemScore.actual_score_sciense
      }

      // set max score for class no sciens class
      if (
        this.model.scoring_cycle_id === 1 &&
        this.model.ac_category_id !== 2
      ) {
        // montly
        return itemScore.actual_score
      }
      if (
        [0, 2, 3].includes(this.model.scoring_cycle_id) &&
        this.model.ac_category_id !== 2
      ) {
        // semester
        if (itemScore.enable_semester) {
          return itemScore.actual_score_semester
        }
        return itemScore.actual_score
      }
    },
    onFetchStudent(classId) {
      this.SET_LOADING(true)
      this.formViewModel({
        fnName: 'student_class',
        class_id: classId
      })
        .then(async response => {
          if (response.status === 200) {
            this.students = response.data.student_class
            await this.fetchEntities()
            this.createStudentScore()
          } else {
            notificationAlert(response)
          }
        })
        .catch(error => {
          notificationAlert(error)
        })
        .finally(() => {
          this.SET_LOADING(false)
        })
    },
    validateInput(score, max) {
      if (score.actual_score > max) {
        score.actual_score = max
      }
    },
    setActualScore(actualScore, averageScore) {
      if (averageScore !== undefined) {
        return parseFloat(averageScore.average_score)
      }
      if (actualScore !== undefined) {
        return actualScore.actual_score
      }
      return ''
    },
    setScoreValue(scores, avg, isMonthly = false) {
      this.model.sc_item_subject_comp_list.forEach(student => {
        const itemScore = scores[student.student_id]
        const average = Object.values(avg).length
          ? avg[student.student_id]
          : undefined

        student.scores.forEach(score => {
          let scoreAverage = undefined
          let actualScore = undefined

          if (average !== undefined) {
            scoreAverage = average.find(
              avg =>
                parseInt(avg.subject_comp_id) == score.sc_item_subject_comp_id
            )
          }
          if (itemScore !== undefined) {
            actualScore = itemScore.find(is => {
              // if score sc_base_id = 2 mean subject base
              if (this.model.score_sc_bas_id == 2) {
                return is.sc_subject_id == score.sc_subject_id
              }
              return is.sc_item_subject_comp_id == score.sc_item_subject_comp_id
            })
          }
          if (!isMonthly) {
            score.scoring_id =
              actualScore !== undefined ? actualScore.scoring_id : ''
          } else {
            score.scoring_id = ''
          }
          score.actual_score = this.setActualScore(actualScore, scoreAverage)
          score.disabledInput = scoreAverage !== undefined
        })
        // reset comment
        student.comments = ''
        student.advisor_id = ''
        student.sc_stu_com_id = ''
      })
    },
    async getAverageScore(componentId, data, isMonthly = false) {
      let averageResponse = await getScoreComponentAverage({
        class_id: this.model.class_id,
        ac_term_id: this.model.ac_term_id,
        grade_id: this.model.grade_id,
        scoring_cycle_id: this.model.m_scoring_cycle_id,
        cycle_value: this.model.m_cycle_value,
        subject_comp_id_list: componentId
      })

      if (this.model.score_type == 1) {
        this.setScoreValue(data, averageResponse, isMonthly)
      }
    },
    async getScoreByTermCycle() {
      const scoreResponse = await getScore({
        class_id: this.model.class_id,
        scoring_cycle_id: this.model.scoring_cycle_id,
        cycle_value: this.model.cycle_value,
        program_structure_id: this.model.program_structure_id,
        score_sc_bas_id: this.model.score_sc_bas_id
      })
      return scoreResponse.data
    },
    async getScoreByMonthlyCycle() {
      const scoreResponse = await getScore({
        class_id: this.model.class_id,
        scoring_cycle_id: this.model.m_scoring_cycle_id,
        cycle_value: this.model.m_cycle_value,
        program_structure_id: this.model.program_structure_id,
        score_sc_bas_id: this.model.score_sc_bas_id
      })
      return scoreResponse.data
    },
    async getScoreByCycleValue() {
      try {
        this.SET_LOADING(true)
        const componentId = this.model.sc_item_subject_comp_list[0].scores.map(
          el => el.sc_item_subject_comp_id
        )
        const termCycleResponse = await this.getScoreByTermCycle()
        if (Object.values(termCycleResponse).length > 0) {
          await this.getAverageScore(componentId, termCycleResponse)
        } else {
          const monthlyCycleResponse = await this.getScoreByMonthlyCycle()
          await this.getAverageScore(componentId, monthlyCycleResponse, true)
        }
      } catch (error) {
        notificationAlert(error)
      } finally {
        this.SET_LOADING(false)
      }
    },
    onStudentRowClickComment(student) {
      this.commentOnStudent = student
      this.inputComment = true
    },
    onCancelComment() {
      this.inputComment = false
      this.commentOnStudent = undefined
    }
  },
  watch: {
    'model.class_id': function(newValue) {
      this.onFetchStudent(newValue)
    },
    'model.m_cycle_value': function() {
      this.getScoreByCycleValue()
    }
  }
}
</script>
